import angular from 'angular';
import uiRouter from 'angular-ui-router';
import analyticsComponent from './analytics-users.component';

let analyticsModule = angular.module('app.containers.analytics-users', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('analyticsUsers', {
      url: '/analytics-users',
      template: '<analytics-users></analytics-users>'
    });
})

.component('analyticsUsers', analyticsComponent);

export default analyticsModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-users/analytics-users.js
 **/